import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-9998",
  "use": "icon-9998-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-9998\" viewBox=\"0 0 16 16\" id=\"icon-9998\">\n  <path d=\"M15.53 13.135 8.653 1.886a.553.553 0 0 0-.944 0L.832 13.135a.553.553 0 0 0 .472.841h13.754a.553.553 0 0 0 .472-.841zm-7.349-1.686a.629.629 0 1 1 0-1.258.629.629 0 0 1 0 1.258zm.426-1.831h-.853l-.348-2.491a.782.782 0 1 1 1.55 0l-.349 2.491z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol